import { Grid } from "@mui/material";
import * as React from "react";
import * as calendarTaskService from "../../../models/services/calendarTaskService";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppUtils } from "../../../framework/appUtils";
import { ISessionState } from "../../../models/session/sessionState";
import { IUnitNodePermissions } from "../../../models/unit/unitNodePermissions";
import { Dialog } from "../../framework/Dialog/Dialog";
import { IPageNavMenuItem, PageNavMenuItems } from "../../framework/PageNav/PageNavMenuItems";
import { GridRow } from "source/components/framework/Grid/GridRow";
import { CalendarTaskCategoryList } from "./CalendarTaskCategoryList";
import { UnitPermissionSettingsNew } from "source/components/unit/Unit/UnitPermissionSettingsNew";

/* eslint-disable no-unused-vars */
export const enum CalendarTaskSettingsDialogMenuItem {
    Permissions = "1",
    Categories = "2",
    DefaultCategories = "3"
}
/* eslint-enable no-unused-vars */

//CalendarTaskSettingsDialog
export interface ICalendarTaskSettingsDialogProp {
    sessionState: ISessionState;
    companyId: string;
    classes?: string;
    settingsActions: IPageNavMenuItem[];
    onClose: (refreshView: boolean) => void;
}

export interface ICalendarTaskSettingsDialogState {
    // Permissions
    unitNodePermissions: IUnitNodePermissions;

    activeMenuItem: CalendarTaskSettingsDialogMenuItem;
}

export class CalendarTaskSettingsDialog extends React.Component<ICalendarTaskSettingsDialogProp, ICalendarTaskSettingsDialogState> {
    private permissionsRef = React.createRef<UnitPermissionSettingsNew>();

    constructor(props: ICalendarTaskSettingsDialogProp) {
        super(props);
        this.state = {
            unitNodePermissions: null,
            activeMenuItem: CalendarTaskSettingsDialogMenuItem.Permissions,
        };
    }

    async componentDidMount(): Promise<void> {
        await this.loadPermissions();
    }

    // #region Permissions
    onUnitPermissionSettingsCancel = async (): Promise<boolean> => {
        return await this.permissionsRef.current.handleCancel(false);
    };

    loadPermissions = async () => {
        const result = await AppUtils.callService(() => calendarTaskService.getUnitNodePermissions(this.props.companyId), false);
        if (!result) return;
        this.setState({
            unitNodePermissions: result
        });
    };

    handleUnitPermissionSettingsSave = async (obj: any) => {
        const result = await calendarTaskService.saveUnitNodePermissions(obj);
        this.loadPermissions();
        return result;
    };
    // #endregion Permissions

    handleSubViewOk = (_closeDialog: boolean) => {
    };

    handleToggleActiveMenuItem = async (menuItem: CalendarTaskSettingsDialogMenuItem) => {
        const state = this.state;
        if (state.activeMenuItem === menuItem) return;
        //Check current tab cancel
        if (state.activeMenuItem === CalendarTaskSettingsDialogMenuItem.Permissions) {
            if (!await this.onUnitPermissionSettingsCancel()) return;
        }
        //Load new tab data
        if (menuItem === CalendarTaskSettingsDialogMenuItem.Permissions) {
            await this.loadPermissions();
        }
        //Set new tab active
        this.setState({
            activeMenuItem: menuItem
        });
    };

    handleCancel = async (closeDialog: boolean) => {
        if (!closeDialog) return;
        this.props.onClose(true);
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <Dialog
                id="calendarTaskSettingsDialog"
                title={Translations.Settings}
                maxWidth="lg"
                maxHeight="100%"
                onClose={() => this.handleCancel(true)}
                body={
                    <GridRow flexGrow={2}>
                        <Grid item sm={3}>
                            <PageNavMenuItems
                                activeId={state.activeMenuItem}
                                items={props.settingsActions}
                                onToggleMenuItem={this.handleToggleActiveMenuItem}
                            />
                        </Grid>
                        <Grid item sm={9} display="flex" flexDirection="column" flexGrow={2}>
                            {state.activeMenuItem === CalendarTaskSettingsDialogMenuItem.Permissions && (
                                <UnitPermissionSettingsNew
                                    ref={this.permissionsRef}
                                    infoText={Translations.CalendarTaskModuleInfoPermissions}
                                    companyId={props.companyId}
                                    unitNodePermissions={state.unitNodePermissions}
                                    cardView={true}
                                    onSave={this.handleUnitPermissionSettingsSave}
                                    onOk={this.handleSubViewOk}
                                    onCancel={this.handleCancel}
                                />
                            )}
                            {(state.activeMenuItem === CalendarTaskSettingsDialogMenuItem.Categories || state.activeMenuItem === CalendarTaskSettingsDialogMenuItem.DefaultCategories) &&
                                <CalendarTaskCategoryList
                                    companyId={state.activeMenuItem === CalendarTaskSettingsDialogMenuItem.Categories ? props.companyId : null}
                                />
                            }
                        </Grid>
                    </GridRow>
                }
                buttons={
                    state.activeMenuItem !== CalendarTaskSettingsDialogMenuItem.Permissions
                        ? [{ title: Translations.Close, variant: "outlined", onClick: () => this.handleCancel(true) }]
                        : null
                }
            />
        );
    }
}